define('lq/observable',['underscore'], function (_) {
    'use strict';

    function Observable(obj, events) {
        this.obj = obj;
        this.eventListeners = {};
        this.events = events ? _.flatten([events]) : null;
    }

    Observable.prototype.addListener = function (event, listener) {
        this.checkEvent(event);
        this.eventListeners[event].push(listener);
        return this.obj;
    };

    Observable.prototype.addOnceListener = function (event, listener) {
        var self = this;
        var listenerWrapper = function () {
            listener.apply(this, arguments);
            self.removeListener(event, listenerWrapper);
        }
        listenerWrapper.wrappedListener = listener; // to support removeListener for wrapped listeners
        this.addListener(event, listenerWrapper);
        return this.obj;
    };

    Observable.prototype.removeListener = function (event, listener) {
        this.checkEvent(event);
        var actualListener = _.find(this.eventListeners[event], function (current) {
            return current === listener || current.wrappedListener === listener;
        });
        if (actualListener) {
            var index = this.eventListeners[event].indexOf(actualListener);
            this.eventListeners[event].splice(index, 1);
        }
        return this.obj;
    };

    Observable.prototype.informListeners = function (event /*, eventArgs... */) {
        this.checkEvent(event);

        var eventArgs = _.drop(arguments, 1);

        // have to use slice() because of the once-listeners
        _.forEach(this.eventListeners[event].slice(), function (listener) {
            listener.apply(this, eventArgs);
        });
        return this.obj;
    };

    Observable.prototype.getListeners = function (event) {
        this.checkEvent(event);
        return this.eventListeners[event].slice(); // returns cloned array to avoid modifications
    };

    Observable.prototype.checkEvent = function (event) {
        if (this.events && !_.contains(this.events, event))
            throw new RangeError("Tried to use missing event: " + event);
        if (!this.eventListeners[event])
            this.eventListeners[event] = [];
    };

    Observable.prototype.addObservableEvents = function (/* event1, event2 or [event1, event2] */) {
        if (!this.events) {
            return;
        }
        if (!arguments.length || !arguments[0]) {
            this.events = null;
        }
        var self = this;
        _.chain(arguments)
            .flatten()
            .compact()
            .each(function (event) {
                self.events.push(event);
            });
        return this.obj;
    };

    return {
        makeObservable: function (obj, events) {
            if (obj.addObservableEvents) {
                obj.addObservableEvents(events);
                return;
            }
            var observable = new Observable(obj, events);
            obj.addListener = _.bind(observable.addListener, observable);
            obj.addOnceListener = _.bind(observable.addOnceListener, observable);
            obj.informListeners = _.bind(observable.informListeners, observable);
            obj.removeListener = _.bind(observable.removeListener, observable);
            obj.getListeners = _.bind(observable.getListeners, observable);
            obj.addObservableEvents = _.bind(observable.addObservableEvents, observable);
        }
    };
});
